module.exports = __webpack_public_path__ + "img/loader.e5059b39.gif";